let language = {
    STORE_AUTH_MODAL_TITLE: "Update Shopify APP",
    STORE_AUTH_ACCESS_TEXT: "Please Authenticeate for {{appName}} Access to: ",
    STORE_AUTH_FOLLOWING_SERVICE: "If you agree grant {{appName}} access to the above content, you will be able to add the following {{appName}} services:",

    STORE_AUTH_CONFIRM_UPDATE_BTN_TEXT: "UPDATE",

    STORE_AUTH_SCOPE_DISCOUNT: "Access Discount Features",
    STORE_AUTH_SCOPE_PRICE_RULE: "Access Price Rule Management",
    STORE_AUTH_SCOPE_SHIPPING: "Access Shipping Details",
    STORE_AUTH_SCOPE_ASSIGNED_FULFILLMENT_ORDERS: "Access Assign Fulfillment Orders",
    STORE_AUTH_SCOPE_DELIVERY_CUSTOMIZATIONS: "Access Delivery Customizations",
    STORE_AUTH_FULFILLMENTS: "Access Fulfillments",
    STORE_AUTH_MANAGED_FULFILLMENT_ORDER: "Access Manage Fulfillment Orders",
    STORE_AUTH_LOCATIONS: "Access Locations",
    STORE_AUTH_SCOPE_APP: "APP",
    STORE_AUTH_SCOPE_YOUR_STORE: "Your Store",
    STORE_AUTH_SCOPE_ACCESS_DESCRIPTION: `To make use of {{appName}}'s latest functionalities, please authorize {{appName}} to access the following mentioned contents.`,

    STORE_AUTH_FEATURE_PRICE_TABLE: "Price Table",
    STORE_AUTH_FEATURE_SHIPPING_METHOD: "Shipping Method",
    STORE_AUTH_FEATURE_TRACKING_NO: "Tracking Number",

    STORE_AUTH_SCOPE_ACCESS_DESCRIPTION_COMPLETED: "Your store has been successfully upgraded. Please refresh the page to get the latest store status."
};

export { language }